(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('PaymentSlipSearchController', PaymentSlipSearchController)

    /** @ngInject */
    function PaymentSlipSearchController(HelperService, PaymentSlipService, sweetAlert) {
        const vm = this;

        let forcePaginationReset = false;

        vm.isSearchDisabled = () => {
            if (vm.selectedSearchField && vm.searchText)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if ((event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;
                vm.isFirstRun = false;

                vm.tableCallServer();
            }
        }

        vm.tableCallServer = (tableState, stCtrl) => {
            if (!vm.stCtrl && stCtrl)
                vm.stCtrl = stCtrl;

            if (!tableState && vm.stCtrl) {
                vm.stCtrl.pipe();
                return;
            }

            if (vm.isFirstRun)
                return;

            vm.isLoading = true;

            if (forcePaginationReset) {
                tableState.pagination.start = 0;
                forcePaginationReset = false;
            }

            const pagination = tableState.pagination;
            const start = pagination.start || 0;
            const number = pagination.number || 10;

            getPaymentRemittanceSlips(start, number, tableState);
        }

        vm.deletePaymentSlip = paymentSlipId => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    HelperService.startLoading('.page-content');

                    PaymentSlipService
                        .delete(paymentSlipId)
                        .then(() => {
                            vm.tableCallServer();

                            HelperService.stopLoading('.page-content');
                            HelperService.successCallback('delete');
                        }, error => {
                            HelperService.errorCallback(error);
                            HelperService.stopLoading('.page-content');
                        })
                }
            })
        }

        vm.changeSlipStatus = (paymentSlip, isPaid) => {
            let message = 'Essa ação irá marcar o boleto como PAGO no sistema!';

            if (!isPaid)
                message = 'Essa ação irá marcar o boleto como NÃO PAGO no sistema!';

            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: message,
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    HelperService.startLoading('.page-content');

                    PaymentSlipService
                        .changePaidStatus(paymentSlip.Id, isPaid)
                        .then(success => {
                            if (isPaid) {
                                paymentSlip.PaymentConfirmation = success;
                                paymentSlip.PaymentConfirmationId = success.Id;
                            } else {
                                paymentSlip.PaymentConfirmation = null;
                                paymentSlip.PaymentConfirmationId = null;
                            }

                            HelperService.stopLoading('.page-content');
                            HelperService.successCallback('delete');
                        }, error => {
                            HelperService.errorCallback(error);
                            HelperService.stopLoading('.page-content');
                        })
                }
            })
        }

        vm.getPaymentStatusText = PaymentSlipService.getPaymentStatusText;
        vm.getPaymentStatusClass = PaymentSlipService.getPaymentStatusClass;

        init();

        function getPaymentRemittanceSlips(skip, perPage, tableState) {
            let parameters = prepareParameters(skip, perPage, tableState);

            PaymentSlipService
                .getByParameters(parameters)
                .then(success => {
                    vm.paymentSlips = success.Slips;
                    tableState.pagination.numberOfPages = success.NumberOfPages;

                    vm.isLoading = false;
                }, error => {
                    vm.paymentSlips = null;
                    vm.isLoading = false;
                    HelperService.errorCallback(error);
                })
        }

        function prepareParameters(skip, perPage, tableState) {
            let params = {
                Skip: skip,
                PerPage: perPage,
                OrderBy: 'Id',
                OrderDescending: false
            }

            if (tableState.sort.predicate) {
                params.OrderBy = tableState.sort.predicate;
                params.OrderDescending = tableState.sort.reverse;
            }

            if (vm.selectedSearchField && vm.searchText) {
                params.SearchField = vm.selectedSearchField.Value;
                params.SearchQuery = vm.searchText;
            }

            return params;
        }

        function init() {
            vm.selectedSearchField;
            vm.searchText;
            vm.isFirstRun = true;
            vm.isLoading = false;

            vm.searchFields = [{
                Id: 1,
                Value: 'PaymentSlipNumber',
                Description: 'Nº Boleto'
            }, {
                Id: 2,
                Value: 'PayerName',
                Description: 'Unidade'
            }, {
                Id: 3,
                Value: 'PayerCNPJ',
                Description: 'CNPJ'
            }, {
                Id: 4,
                Value: 'PaymentRemittanceId',
                Description: 'Id da Remessa'
            }];
        }
    }
}());